import { __assign } from './../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
import AnalyticsOutline from '../../assets/icons/outline/AnalyticsOutline.js';
import AutomationOutline from '../../assets/icons/outline/AutomationOutline.js';
import BrandsOutline from '../../assets/icons/outline/BrandsOutline.js';
import BusinessAnalyticsOutline from '../../assets/icons/outline/BusinessAnalyticsOutline.js';
import CatalogueOutline from '../../assets/icons/outline/CatalogueOutline.js';
import CustomersOutline from '../../assets/icons/outline/CustomersOutline.js';
import DashboardOutline from '../../assets/icons/outline/DashboardOutline.js';
import FeedbackOutline from '../../assets/icons/outline/FeedbackOutline.js';
import GlobeOutline from '../../assets/icons/outline/GlobeOutline.js';
import GroupsOutline from '../../assets/icons/outline/GroupsOutline.js';
import HelpOutline from '../../assets/icons/outline/HelpOutline.js';
import HomeOutline from '../../assets/icons/outline/HomeOutline.js';
import InventoryOutline from '../../assets/icons/outline/InventoryOutline.js';
import KDSOutline from '../../assets/icons/outline/KDSOutline.js';
import LocationsOutline from '../../assets/icons/outline/LocationsOutline.js';
import MarketingOutline from '../../assets/icons/outline/MarketingOutline.js';
import MenusOutline from '../../assets/icons/outline/MenusOutline.js';
import MerakiOutline from '../../assets/icons/outline/MerakiOutline.js';
import OnlineOrdersOutline from '../../assets/icons/outline/OnlineOrdersOutline.js';
import PeriscopeOutline from '../../assets/icons/outline/PeriscopeOutline.js';
import PlatformAppsOutline from '../../assets/icons/outline/PlatformAppsOutline.js';
import PointOfSaleOutline from '../../assets/icons/outline/PointOfSaleOutline.js';
import ProductUpdatesOutline from '../../assets/icons/outline/ProductUpdatesOutline.js';
import PromotionsOutline from '../../assets/icons/outline/PromotionsOutline.js';
import RawMaterialsOutline from '../../assets/icons/outline/RawMaterialsOutline.js';
import RecipesOutline from '../../assets/icons/outline/RecipesOutline.js';
import ReconcilationOutline from '../../assets/icons/outline/ReconciliationOutline.js';
import ReportsOutline from '../../assets/icons/outline/ReportsOutline.js';
import SchedulesOutline from '../../assets/icons/outline/SchedulesOutline.js';
import SettingsOutline from '../../assets/icons/outline/SettingsOutline.js';
import SupportOutline from '../../assets/icons/outline/SupportOutline.js';
import AnalyticsFilled from '../../assets/icons/filled/AnalyticsFilled.js';
import AutomationFilled from '../../assets/icons/filled/AutomationFilled.js';
import BrandsFilled from '../../assets/icons/filled/BrandsFilled.js';
import BusinessAnalyticsFilled$1 from '../../assets/icons/filled/BusinessAnalyticsFilled.js';
import CatalogueFilled$1 from '../../assets/icons/filled/CatalogueFilled.js';
import CustomersFilled from '../../assets/icons/filled/CustomersFilled.js';
import DashboardFilled from '../../assets/icons/filled/DashboardFilled.js';
import FeedbackFilled from '../../assets/icons/filled/FeedbackFilled.js';
import GlobeFilled from '../../assets/icons/filled/GlobeFilled.js';
import GroupsFilled from '../../assets/icons/filled/GroupsFilled.js';
import HelpFilled from '../../assets/icons/filled/HelpFilled.js';
import HomeFilled from '../../assets/icons/filled/HomeFilled.js';
import InventoryFilled from '../../assets/icons/filled/InventoryFilled.js';
import KDSFilled from '../../assets/icons/filled/KDSFilled.js';
import LocationsFilled from '../../assets/icons/filled/LocationsFilled.js';
import MarketingFilled from '../../assets/icons/filled/MarketingFilled.js';
import MenusFilled from '../../assets/icons/filled/MenusFilled.js';
import MerakiFilled from '../../assets/icons/filled/MerakiFilled.js';
import OnlineOrdersFilled from '../../assets/icons/filled/OnlineOrdersFilled.js';
import PeriscopeFilled from '../../assets/icons/filled/PeriscopeFilled.js';
import PlatformAppsFilled from '../../assets/icons/filled/PlatformAppsFilled.js';
import PointOfSaleFilled from '../../assets/icons/filled/PointOfSaleFilled.js';
import ProductUpdatesFilled from '../../assets/icons/filled/ProductUpdatesFilled.js';
import PromotionsFilled from '../../assets/icons/filled/PromotionsFilled.js';
import CatalogueFilled from '../../assets/icons/filled/RawMaterialsFilled.js';
import RecipesFilled from '../../assets/icons/filled/RecipesFilled.js';
import ReconciliationFilled from '../../assets/icons/filled/ReconciliationFilled.js';
import ReportsFilled from '../../assets/icons/filled/ReportsFilled.js';
import SchedulesFilled from '../../assets/icons/filled/SchedulesFilled.js';
import SettingsFilled from '../../assets/icons/filled/SettingsFilled.js';
import BusinessAnalyticsFilled from '../../assets/icons/filled/SupportFilled.js';
function getSideNavOutlineIcon(key, props) {
  if (key === void 0) {
    key = '';
  }
  if (props === void 0) {
    props = {};
  }
  if (!key) {
    return null;
  }
  var SideNavOutlineIcon = null;
  switch (key) {
    case 'analytics':
      SideNavOutlineIcon = AnalyticsOutline;
      break;
    case 'automation':
      SideNavOutlineIcon = AutomationOutline;
      break;
    case 'brands':
      SideNavOutlineIcon = BrandsOutline;
      break;
    case 'business-analytics':
      SideNavOutlineIcon = BusinessAnalyticsOutline;
      break;
    case 'catalogue':
      SideNavOutlineIcon = CatalogueOutline;
      break;
    case 'customers':
      SideNavOutlineIcon = CustomersOutline;
      break;
    case 'dashboard':
      SideNavOutlineIcon = DashboardOutline;
      break;
    case 'feedback':
      SideNavOutlineIcon = FeedbackOutline;
      break;
    case 'globe':
      SideNavOutlineIcon = GlobeOutline;
      break;
    case 'groups':
      SideNavOutlineIcon = GroupsOutline;
      break;
    case 'help':
      SideNavOutlineIcon = HelpOutline;
      break;
    case 'home':
      SideNavOutlineIcon = HomeOutline;
      break;
    case 'inventory':
      SideNavOutlineIcon = InventoryOutline;
      break;
    case 'kds':
      SideNavOutlineIcon = KDSOutline;
      break;
    case 'locations':
      SideNavOutlineIcon = LocationsOutline;
      break;
    case 'marketing':
      SideNavOutlineIcon = MarketingOutline;
      break;
    case 'menus':
      SideNavOutlineIcon = MenusOutline;
      break;
    case 'meraki':
      SideNavOutlineIcon = MerakiOutline;
      break;
    case 'online-orders':
      SideNavOutlineIcon = OnlineOrdersOutline;
      break;
    case 'periscope':
      SideNavOutlineIcon = PeriscopeOutline;
      break;
    case 'platform-apps':
      SideNavOutlineIcon = PlatformAppsOutline;
      break;
    case 'point-of-sale':
      SideNavOutlineIcon = PointOfSaleOutline;
      break;
    case 'product-updates':
      SideNavOutlineIcon = ProductUpdatesOutline;
      break;
    case 'promotions':
      SideNavOutlineIcon = PromotionsOutline;
      break;
    case 'raw-materials':
      SideNavOutlineIcon = RawMaterialsOutline;
      break;
    case 'recipes':
      SideNavOutlineIcon = RecipesOutline;
      break;
    case 'reconciliation':
      SideNavOutlineIcon = ReconcilationOutline;
      break;
    case 'reports':
      SideNavOutlineIcon = ReportsOutline;
      break;
    case 'schedules':
      SideNavOutlineIcon = SchedulesOutline;
      break;
    case 'settings':
      SideNavOutlineIcon = SettingsOutline;
      break;
    case 'support':
      SideNavOutlineIcon = SupportOutline;
      break;
  }
  if (SideNavOutlineIcon) {
    return React__default.createElement(SideNavOutlineIcon, __assign({}, props));
  }
  return null;
}
function getSideNavFilledIcon(key, props) {
  if (key === void 0) {
    key = '';
  }
  if (props === void 0) {
    props = {};
  }
  if (!key) {
    return null;
  }
  var SideNavFilledIcon = null;
  switch (key) {
    case 'analytics':
      SideNavFilledIcon = AnalyticsFilled;
      break;
    case 'automation':
      SideNavFilledIcon = AutomationFilled;
      break;
    case 'brands':
      SideNavFilledIcon = BrandsFilled;
      break;
    case 'business-analytics':
      SideNavFilledIcon = BusinessAnalyticsFilled$1;
      break;
    case 'catalogue':
      SideNavFilledIcon = CatalogueFilled$1;
      break;
    case 'customers':
      SideNavFilledIcon = CustomersFilled;
      break;
    case 'dashboard':
      SideNavFilledIcon = DashboardFilled;
      break;
    case 'feedback':
      SideNavFilledIcon = FeedbackFilled;
      break;
    case 'globe':
      SideNavFilledIcon = GlobeFilled;
      break;
    case 'groups':
      SideNavFilledIcon = GroupsFilled;
      break;
    case 'help':
      SideNavFilledIcon = HelpFilled;
      break;
    case 'home':
      SideNavFilledIcon = HomeFilled;
      break;
    case 'inventory':
      SideNavFilledIcon = InventoryFilled;
      break;
    case 'kds':
      SideNavFilledIcon = KDSFilled;
      break;
    case 'locations':
      SideNavFilledIcon = LocationsFilled;
      break;
    case 'marketing':
      SideNavFilledIcon = MarketingFilled;
      break;
    case 'menus':
      SideNavFilledIcon = MenusFilled;
      break;
    case 'meraki':
      SideNavFilledIcon = MerakiFilled;
      break;
    case 'online-orders':
      SideNavFilledIcon = OnlineOrdersFilled;
      break;
    case 'periscope':
      SideNavFilledIcon = PeriscopeFilled;
      break;
    case 'platform-apps':
      SideNavFilledIcon = PlatformAppsFilled;
      break;
    case 'point-of-sale':
      SideNavFilledIcon = PointOfSaleFilled;
      break;
    case 'product-updates':
      SideNavFilledIcon = ProductUpdatesFilled;
      break;
    case 'promotions':
      SideNavFilledIcon = PromotionsFilled;
      break;
    case 'raw-materials':
      SideNavFilledIcon = CatalogueFilled;
      break;
    case 'recipes':
      SideNavFilledIcon = RecipesFilled;
      break;
    case 'reconciliation':
      SideNavFilledIcon = ReconciliationFilled;
      break;
    case 'reports':
      SideNavFilledIcon = ReportsFilled;
      break;
    case 'schedules':
      SideNavFilledIcon = SchedulesFilled;
      break;
    case 'settings':
      SideNavFilledIcon = SettingsFilled;
      break;
    case 'support':
      SideNavFilledIcon = BusinessAnalyticsFilled;
      break;
  }
  if (SideNavFilledIcon) {
    return React__default.createElement(SideNavFilledIcon, __assign({}, props));
  }
  return null;
}
export { getSideNavFilledIcon, getSideNavOutlineIcon };
//# sourceMappingURL=index.js.map
